import { render, staticRenderFns } from "./ConvoEvaluation.vue?vue&type=template&id=24a88fbc&"
import script from "./ConvoEvaluation.vue?vue&type=script&lang=js&"
export * from "./ConvoEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports